import { useEffect, useState } from "react";
import { api } from "../../services/apiClient";
import { apiErrorToMessage } from "../../services/apiError";
import { useI18n } from "../../i18n/localization";
import { useAdminSession } from "../admin/AdminSessionGate";
import { sortByStart, formatWhen, type Meeting } from "./scheduleView";

// Scheduled-meetings list (preference 1, design/05). POC: lists upcoming meetings with a
// Cancel action (the former Join opened the retired /station workstation). Rendering logic is the pure
// scheduleView helpers. Rendered inside <AdminSessionGate>: the /schedule APIs require the
// administrator session server-side.
export function Schedule() {
  const { t, dir } = useI18n();
  const { session, guard } = useAdminSession();
  const [meetings, setMeetings] = useState<Meeting[]>([]);
  const [error, setError] = useState<string | null>(null);

  const load = () =>
    guard(api.get<Meeting[]>("/schedule", session.token))
      .then((m) => { setMeetings(sortByStart(m)); setError(null); })
      .catch((e: unknown) => setError(apiErrorToMessage(e, t)));

  useEffect(() => {
    void load();
    // reload when the session is replaced
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [session.token]);

  const cancel = async (id: number) => {
    await guard(api.delete<void>(`/schedule/${id}`, session.token)).catch((e: unknown) => setError(apiErrorToMessage(e, t)));
    void load();
  };

  return (
    <main style={{ padding: 24, fontFamily: "Segoe UI, Arial, sans-serif", maxWidth: 720, margin: "0 auto" }} dir={dir}>
      <h1 style={{ color: "#14305f", fontSize: 19 }}>{t.schedule.title}</h1>
      {error && <div style={{ color: "#b91c1c", fontSize: 13 }}>{error}</div>}
      {meetings.length === 0 && <p style={{ color: "#5b6b82", fontSize: 14 }}>{t.schedule.none}</p>}
      <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
        {meetings.map((mtg) => (
          <li
            key={mtg.meetingId}
            style={{
              display: "flex", alignItems: "center", justifyContent: "space-between",
              padding: "10px 12px", border: "1px solid #d6deea", borderRadius: 8, marginBottom: 8, background: "#fff"
            }}
          >
            <span style={{ fontSize: 14 }}>
              <strong>{formatWhen(mtg.scheduledStart)}</strong>
              <span style={{ color: "#64748b" }}> · {mtg.durationMin} {t.schedule.duration}</span>
              {mtg.caseRef && <span style={{ color: "#64748b" }}> · {t.schedule.caseRef} {mtg.caseRef}</span>}
            </span>
            {/* No Join action: it opened the retired officer workstation (/station). */}
            <span style={{ display: "flex", gap: 8 }}>
              <button
                onClick={() => cancel(mtg.meetingId)}
                style={{ background: "#e2e8f0", color: "#1e2a3a", border: "none", borderRadius: 6, padding: "6px 16px", cursor: "pointer" }}
              >
                {t.schedule.cancel}
              </button>
            </span>
          </li>
        ))}
      </ul>
    </main>
  );
}
